import { type LucideProps } from "lucide-react";

import { ICONS, type IconV2Name } from "./icons";

export type IconV2Size = "xs" | "s" | "m" | "l";

const SIZE_PX: Record<IconV2Size, number> = { xs: 8, s: 12, m: 16, l: 20 };

interface Props extends Omit<LucideProps, "size"> {
  name: IconV2Name;
  size?: IconV2Size;
}

export const IconV2 = ({ name, size = "m", ...rest }: Props) => {
  const Component = ICONS[name];
  return <Component size={SIZE_PX[size]} {...rest} />;
};
